import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { Menu, Phone, X } from "lucide-react";
import { CALL_URL, PHONE_DISPLAY } from "./ContactButtons";

const LINKS = [
  { label: "The House", href: "#about", id: "about" },
  { label: "Gallery", href: "#gallery", id: "gallery" },
  { label: "Location", href: "#location", id: "location" },
  { label: "Guest Voices", href: "#reviews", id: "reviews" },
  { label: "Arrive", href: "#contact", id: "contact" },
];

export const Nav = () => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    document.body.style.overflow = open ? "hidden" : "";
    return () => {
      document.body.style.overflow = "";
    };
  }, [open]);

  return (
    <header
      data-testid="site-nav"
      className="fixed inset-x-0 top-0 z-50 border-b border-white/5 bg-[#121214]/60 backdrop-blur-xl"
    >
      <div className="mx-auto flex max-w-7xl items-center justify-between px-6 py-4 md:px-10">
        <a href="#top" data-testid="nav-brand" className="flex shrink-0 flex-col leading-none">
          <span className="whitespace-nowrap font-serif text-[1.35rem] tracking-[0.2em] text-[#F5F5F0]">PIPEWALAS</span>
          <span className="mt-1.5 whitespace-nowrap text-[9px] font-semibold tracking-[0.4em] text-[#C5A059]">
            HOUSE &amp; HOMESTAYS
          </span>
        </a>

        <nav className="hidden items-center gap-9 lg:flex">
          {LINKS.map((l) => (
            <a
              key={l.id}
              data-testid={`nav-${l.id}-link`}
              href={l.href}
              className="text-xs font-medium uppercase tracking-[0.25em] text-[#A1A1AA] transition-colors duration-300 hover:text-[#C5A059]"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="hidden items-center gap-6 lg:flex">
          <a
            data-testid="nav-phone-link"
            href={CALL_URL}
            className="hidden items-center gap-2 text-xs font-semibold tracking-wider text-[#F5F5F0]/80 transition-colors hover:text-[#C5A059] lg:flex"
          >
            <Phone className="h-3.5 w-3.5 text-[#C5A059]" />
            {PHONE_DISPLAY}
          </a>
          <a
            data-testid="nav-book-cta"
            href="#contact"
            className="rounded-full border border-[#C5A059]/50 px-6 py-2.5 text-xs font-semibold uppercase tracking-[0.2em] text-[#C5A059] transition-[transform,background-color,color] duration-500 hover:-translate-y-0.5 hover:bg-[#C5A059] hover:text-[#080809]"
          >
            Book Your Stay
          </a>
        </div>

        <button
          data-testid="nav-mobile-menu-button"
          onClick={() => setOpen(!open)}
          className="text-[#F5F5F0] lg:hidden"
          aria-label="Toggle menu"
        >
          {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
        </button>
      </div>

      <AnimatePresence>
        {open && (
          <motion.nav
            data-testid="nav-mobile-menu"
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: "auto" }}
            exit={{ opacity: 0, height: 0 }}
            transition={{ duration: 0.4, ease: [0.16, 1, 0.3, 1] }}
            className="overflow-hidden border-t border-white/5 bg-[#0c0c0e]/95 backdrop-blur-xl lg:hidden"
          >
            <div className="flex flex-col gap-6 px-6 py-8">
              {LINKS.map((l) => (
                <a
                  key={l.id}
                  data-testid={`nav-mobile-${l.id}-link`}
                  href={l.href}
                  onClick={() => setOpen(false)}
                  className="font-serif text-3xl text-[#F5F5F0] transition-colors hover:text-[#C5A059]"
                >
                  {l.label}
                </a>
              ))}
            </div>
          </motion.nav>
        )}
      </AnimatePresence>
    </header>
  );
};
